var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"grey lighten-3",style:(_vm.isMobile ? 'padding-bottom: 60px' : '')},[_c('v-container',{staticClass:"pt-0",class:_vm.isDesktop ? 'd-flex pa-0' : '',attrs:{"fluid":""}},[(_vm.isDesktop)?_c('LoginBanner'):_vm._e(),_c('div',{class:[
        _vm.isDesktop ? 'login-direita pt-10' : '',
        _vm.isDesktopLarge ? 'login-direita-lg pt-lg-12' : '' ]},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }